import React from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import ErrorBoundary from '@wix/da-shared-react/pkg/ErrorBoundary';
import Sticky from '@wix/da-shared-react/pkg/Sticky';
import { getStickyContentHeight } from '../../helpers';
import { isViewingAsVisitor } from '../../../../selectors/users';
import variables from '../../../../styles/variables.scss';

import * as s from './StickyBar.scss';

const viewAsVisitorHeight = parseInt(
  variables['view-as-visitor-bar-height'],
  10
);

export interface Props {
  children(isStuck: boolean): React.ReactNode;
}

export const StickyBar: React.FC<Props> = props => {
  const asVisitor = useSelector(isViewingAsVisitor);
  return (
    <ErrorBoundary>
      <div className={s['wrapper-placeholder']}>
        <Sticky
          className={s['sticky']}
          marginTop={
            getStickyContentHeight() + (asVisitor ? viewAsVisitorHeight : 0)
          }
        >
          {isStuck => (
            <div className={classnames(s['content'], isStuck && s['stuck'])}>
              {props.children(isStuck)}
            </div>
          )}
        </Sticky>
      </div>
    </ErrorBoundary>
  );
};
StickyBar.displayName = 'StickyBar';

export default StickyBar;
